import { render, staticRenderFns } from "./TaxCreditLevel.vue?vue&type=template&id=571927aa&scoped=true"
import script from "./TaxCreditLevel.vue?vue&type=script&lang=js"
export * from "./TaxCreditLevel.vue?vue&type=script&lang=js"
import style0 from "./TaxCreditLevel.vue?vue&type=style&index=0&id=571927aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571927aa",
  null
  
)

export default component.exports